import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import integrationVariablesDefault from "../../assets/testData/CMS_Defaults/integrationVariables.json";
import errorDefault from "../../assets/testData/CMS_Defaults/errorDetails.json";
import {
  T_CenterBannerData,
  T_CmsErrorVariable,
  T_CmsHlSuccessMessages,
  T_CmsIntegrationVariables,
  T_CmsOnboardingAnimations,
  T_CmsPageMessage,
  T_CmsPageVariables,
  T_FooterBannerData,
  T_L2BannerData,
  T_MyTrackData,
  T_NewOfferingData,
  T_NudgeBannerData,
  T_TopBannerData,
} from "./CmsGlobal.Types";

interface imgs {
  mobile: string;
  key: string;
}

const initialState: {
  CmsIntegrationVariableData: T_CmsIntegrationVariables[];
  CmsPageVariableData: T_CmsPageVariables[];
  CmsErrorVariablesData: T_CmsErrorVariable[];
  CmsPageMessagesData: T_CmsPageMessage[];
  cmsImages: imgs[];
  CmsHlSuccessMEssages: T_CmsHlSuccessMessages[];
  cmsMyTrackData: T_MyTrackData[];
  cmsTopBannerData: T_TopBannerData[];
  cmsOfferMartTopBannerData: T_TopBannerData[];
  cmsCenterBannerData: T_CenterBannerData[];
  cmsNewOfferingData: T_NewOfferingData[];
  cmsFooterBannerData: T_FooterBannerData[];
  cmsL2BannerData: T_L2BannerData[];
  cmsNudgeBannerData: T_NudgeBannerData[];
  cmsOnboardingAnimations: T_CmsOnboardingAnimations[];
} = {
  CmsIntegrationVariableData:
    integrationVariablesDefault as T_CmsIntegrationVariables[],
  CmsPageVariableData: [],
  CmsErrorVariablesData: errorDefault as T_CmsErrorVariable[],
  CmsPageMessagesData: [],
  cmsImages: [],
  CmsHlSuccessMEssages: [],
  cmsMyTrackData: [],
  cmsTopBannerData: [],
  cmsOfferMartTopBannerData: [],
  cmsCenterBannerData: [],
  cmsNewOfferingData: [],
  cmsFooterBannerData: [],
  cmsL2BannerData: [],
  cmsNudgeBannerData: [],
  cmsOnboardingAnimations: [],
};

const CmsSlice = createSlice({
  name: "CmsSlice",
  initialState: initialState,
  reducers: {
    setPageVariables(state, action: PayloadAction<T_CmsPageVariables[]>) {
      const newCmsImages = action.payload.map((variable) => ({
        key: variable.attributes.image?.data?.attributes.url ?? "",
        mobile: variable.attributes.mobileImage?.data?.attributes.url ?? "",
      }));
      state.cmsImages = [...state.cmsImages, ...newCmsImages];

      state.CmsPageVariableData = action.payload;
    },
    setIntegrationVariables(
      state,
      action: PayloadAction<T_CmsIntegrationVariables[]>,
    ) {
      const newCmsImages = action.payload.map((variable) => ({
        key: variable.attributes.image?.data?.attributes.url ?? "",
        mobile: variable.attributes.mobileImage?.data?.attributes.url ?? "",
      }));
      state.cmsImages = [...state.cmsImages, ...newCmsImages];

      state.CmsIntegrationVariableData = action.payload;
    },
    setErrorVariables(state, action: PayloadAction<T_CmsErrorVariable[]>) {
      state.CmsErrorVariablesData = action.payload;
    },
    setPageMessage(state, action: PayloadAction<T_CmsPageMessage[]>) {
      state.CmsPageMessagesData = action.payload;
    },
    setHlSuccessMessages(
      state,
      action: PayloadAction<T_CmsHlSuccessMessages[]>,
    ) {
      state.CmsHlSuccessMEssages = action.payload;
    },
    setMyTrackData(state, action: PayloadAction<T_MyTrackData[]>) {
      state.cmsMyTrackData = action.payload;
    },
    setTopBannerData(state, action: PayloadAction<T_TopBannerData[]>) {
      state.cmsTopBannerData = action.payload;
    },
    setCmsOfferMartTopBannerData(
      state,
      action: PayloadAction<T_TopBannerData[]>,
    ) {
      state.cmsOfferMartTopBannerData = action.payload;
    },
    setCenterBannerData(state, action: PayloadAction<T_CenterBannerData[]>) {
      state.cmsCenterBannerData = action.payload;
    },
    setNewOfferingData(state, action: PayloadAction<T_NewOfferingData[]>) {
      state.cmsNewOfferingData = action.payload;
    },
    setFooterBannerData(state, action: PayloadAction<T_FooterBannerData[]>) {
      state.cmsFooterBannerData = action.payload;
    },
    setL2BannerData(state, action: PayloadAction<T_L2BannerData[]>) {
      state.cmsL2BannerData = action.payload;
    },
    setNudgeBannerData(state, action: PayloadAction<T_NudgeBannerData[]>) {
      state.cmsNudgeBannerData = action.payload;
    },
    setOnboardingAnimations(
      state,
      action: PayloadAction<T_CmsOnboardingAnimations[]>,
    ) {
      state.cmsOnboardingAnimations = action.payload;
    },
  },
});

export const {
  setPageVariables,
  setIntegrationVariables,
  setErrorVariables,
  setPageMessage,
  setHlSuccessMessages,
  setOnboardingAnimations,
  setMyTrackData,
  setTopBannerData,
  setCmsOfferMartTopBannerData,
  setCenterBannerData,
  setNewOfferingData,
  setFooterBannerData,
  setL2BannerData,
  setNudgeBannerData,
} = CmsSlice.actions;

export const CmsReducer = CmsSlice.reducer;
export const CmsKey = CmsSlice.reducerPath;
